import React from 'react';
import EventTracking from 'lib/EventTracking';
import CoachingConstants from 'coaching/CoachingConstants';
import Image from 'components/Image';
import Link from 'components/Link';
import Row from 'components/Row';
import Text from 'components/Text';
import CoachingHeading from 'coaching/components/CoachingHeading';
import { PurchaseFailureReason } from 'coaching/components/CoachingSelfServeView/CoachingSelfServeView';

type Props = {
  failureReason?: PurchaseFailureReason;
};

export default function CoachingSelfServeFailureView(props: Props) {
  React.useEffect(() => {
    EventTracking.trackKey('coaching.self_schedule_purchase.failure.view');
  }, []);

  if (props.failureReason === 'PURCHASE_FAILURE_DUPLICATE_PURCHASE') {
    {
      return (
        <Text align="center" data-test="duplicate-purchase-error">
          <Row size="small">
            <CoachingHeading>It looks like you’re already signed up</CoachingHeading>
            <Text size="small">
              To book additional sessions,{' '}
              <Link
                weight="semibold"
                underline
                color="ink"
                href={CoachingConstants.COACHING_HOME_ROUTE}>
                go to your Coaching dashboard
              </Link>
              .
            </Text>
          </Row>
          <Row size="xxxlarge">
            <Text size="small">
              For other issues or requests, you can also{' '}
              <Link
                weight="semibold"
                underline
                color="ink"
                href={CoachingConstants.TUTORING_HELP_ROUTE}
                target="_blank">
                get help
              </Link>
              .
            </Text>
          </Row>
          <Image src={require('assets/images/coaching/telescope_doodle.png')} />
        </Text>
      );
    }
  }

  return (
    <Text align="center">
      <Row size="xxxlarge">
        <CoachingHeading>Sorry, something went wrong</CoachingHeading>
        <Text size="small">
          We couldn’t process your information. Please contact us at{' '}
          <Link
            weight="semibold"
            underline
            color="ink"
            href={CoachingConstants.COACHING_HELP_EMAIL_LINK}>
            {CoachingConstants.COACHING_HELP_EMAIL}
          </Link>
        </Text>
      </Row>
      <Image src={require('assets/images/coaching/telescope_doodle.png')} />
    </Text>
  );
}
